// extracted by mini-css-extract-plugin
export default {"item":"item-d83A"};